import validator from 'validator';

/** Validates a string of emails separated by commas. */
function validateEmails(emails) {
  return emails.split(',').every(e => validator.isEmail(e.trim()));
}

export default validateEmails;
